import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Flag from "react-world-flags";

const LanguageSelector: React.FC = () => {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    setOpen(false);
  };

  const currentLang = i18n.language === "es" ? "es" : "en";

  const languages = {
    es: {
      label: t("languageSelector.spanish"),
      flagCode: "ES",
    },
    en: {
      label: t("languageSelector.english"),
      flagCode: "US",
    },
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg
                   text-sm font-semibold
                   text-gray-800 dark:text-gray-200
                   hover:bg-gray-100 dark:hover:bg-gray-800
                   transition-colors"
      >
        <Flag
          code={languages[currentLang].flagCode}
          style={{ width: 18, height: 12 }}
        />

        <span>{languages[currentLang].flagCode}</span>

        <span className="text-xs opacity-70">▼</span>
      </button>

      {open && (
        <div
          className="absolute right-0 mt-2 w-44 z-50
                     bg-white dark:bg-gray-900
                     border border-gray-200 dark:border-gray-700
                     rounded-xl shadow-lg
                     overflow-hidden"
        >
          <button
            onClick={() => changeLanguage("es")}
            className={`flex items-center justify-between w-full px-4 py-2 text-sm transition-colors
              hover:bg-gray-100 dark:hover:bg-gray-800
              ${
                currentLang === "es"
                  ? "bg-gray-100 dark:bg-gray-800 font-semibold"
                  : "text-gray-800 dark:text-gray-200"
              }`}
          >
            <div className="flex items-center gap-2">
              <Flag code="ES" style={{ width: 18, height: 12 }} />
              <span>{languages.es.label}</span>
            </div>

            {currentLang === "es" && (
              <span className="text-blue-500 font-bold">✔</span>
            )}
          </button>

          <button
            onClick={() => changeLanguage("en")}
            className={`flex items-center justify-between w-full px-4 py-2 text-sm transition-colors
              hover:bg-gray-100 dark:hover:bg-gray-800
              ${
                currentLang === "en"
                  ? "bg-gray-100 dark:bg-gray-800 font-semibold"
                  : "text-gray-800 dark:text-gray-200"
              }`}
          >
            <div className="flex items-center gap-2">
              <Flag code="US" style={{ width: 18, height: 12 }} />
              <span>{languages.en.label}</span>
            </div>

            {currentLang === "en" && (
              <span className="text-blue-500 font-bold">✔</span>
            )}
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
